import { subscribeAuthSession } from './authSession'
import {
  applyPosthogConsent,
  initializePosthog,
  resetPosthog,
} from './posthogConsent'
import { trackClientError } from './posthogAnalytics'

export function startPosthogLifecycle() {
  initializePosthog()

  const unsubscribeAuthSession = subscribeAuthSession(({ action }) => {
    if (action === 'cleared') {
      resetPosthog()
      return
    }

    if (action === 'replaced') {
      // 새 세션은 서버 동의 상태를 다시 확인하기 전까지 수집하지 않는다.
      applyPosthogConsent(false)
    }
  })

  const handleWindowError = () => {
    trackClientError({
      errorCode: 'UNHANDLED_WINDOW_ERROR',
      source: 'window',
    })
  }
  const handleUnhandledRejection = () => {
    trackClientError({
      errorCode: 'UNHANDLED_PROMISE_REJECTION',
      source: 'promise',
    })
  }

  window.addEventListener('error', handleWindowError)
  window.addEventListener('unhandledrejection', handleUnhandledRejection)

  return () => {
    unsubscribeAuthSession()
    window.removeEventListener('error', handleWindowError)
    window.removeEventListener('unhandledrejection', handleUnhandledRejection)
  }
}
